import { FormGroup, FormBuilder, Validators, FormArray } from '@angular/forms';
import { Component, ViewChild, Output, EventEmitter, ElementRef, Input, OnInit } from '@angular/core';
import { NavController, NavParams, ModalController, ToastController, Slides, ViewController, AlertController, MenuController, App } from 'ionic-angular';
import { DataService } from "../../../services/data.service";
import createNumberMask from 'text-mask-addons/dist/createNumberMask';
import createAutoCorrectedDatePipe from 'text-mask-addons/dist/createAutoCorrectedDatePipe';
import {RealEstateAssets} from '../../real-estate-assets/real-estate-assets';
import { ADFFormService } from '../../../services/adf-form.service';
declare var google;
@Component({
  selector: 'adf-address-detail',
  templateUrl: 'address-detail.html',

})
export class AddressDetail implements OnInit {
  @Input() editdata: any;
  @ViewChild(Slides) signupSlider: Slides;
  @ViewChild('addresstext') addresstext: any;
  @ViewChild('RealEstateAssets') RealEstateAssets:RealEstateAssets;
  @Output() getAddressFormData_evtemit = new EventEmitter();
  @Output() housingsituation_evtemit1=new EventEmitter();
  @Output() housingsituation_evtemit2=new EventEmitter();
  addreDetail: FormGroup;
  primaryData: FormGroup;
  public applicant_details: any;
  public new_val: any;
  public old_val: any;
  public change_log_string: any;
  public showPrimaryApplicantAddress: number = 1;
  public showAdditional_address: number = -1;
  public indexx: number;
  public aditional_index: number;
  public hidePrimaryApplicant = false;
  formApplicant: FormArray;
  public address_format;
  public dateMask = [/\d/, /\d/, '/', /\d/, /\d/, '/', /\d/, /\d/, /\d/, /\d/];

  public autoCorrectedDatePipe = createAutoCorrectedDatePipe('mm/dd/yyyy HH:MM');
  public numberMask = createNumberMask({
    prefix: '$ ',
    allowDecimal: true,
    decimalSymbol: ".",
    decimalLimit: 2,
    suffix: ' '
  });
  public userdata: any;
  public indexOf_additionalApplicant_previousAddress:number;
  public additionalPreviuosAddress=[];
  public addressDetailIsValid:any;

  constructor(
    public formBuilder: FormBuilder,
    private DataService: DataService,
    private adfFormService: ADFFormService
  ) {
    this.address_format = 'standard';
    this.addreDetail = formBuilder.group({
      address_type: ['Home', Validators.compose([Validators.maxLength(30), Validators.required])],
      address_format: ['standard', Validators.compose([Validators.maxLength(30), Validators.required])],
      full_address: [''],
      floor_number: ['', Validators.compose([Validators.maxLength(30)])],
      unit_number: ['', Validators.compose([Validators.maxLength(30)])],
      building_name: ['', Validators.compose([Validators.maxLength(30)])],
      street_number: ['', Validators.compose([Validators.maxLength(30), Validators.required])],
      street_name: ['', Validators.compose([Validators.maxLength(30), Validators.required])],
      street_type: ['', Validators.compose([Validators.maxLength(30), Validators.required])],
      poboxlabel: ['', Validators.compose([Validators.maxLength(30)])],
      city: ['', Validators.compose([Validators.maxLength(30), Validators.required])],
      state: ['', Validators.compose([Validators.maxLength(30), Validators.required])],
      postcode: ['', Validators.compose([Validators.required, Validators.minLength(4), Validators.maxLength(4), Validators.required])],
      country: ['Australia', Validators.compose([Validators.required])],
      housing_situation: ['',Validators.compose([Validators.required])],
      move_in_date: ['', Validators.compose([Validators.required])],
      addPreviousAddressItem: this.formBuilder.array([]),
      addAddressRelationshipItem: this.formBuilder.array([]),
      addPreviosRelationAddressItem: this.formBuilder.array([])
    });

    this.primaryData = formBuilder.group({
      firstname: ['', Validators.compose([Validators.maxLength(30), Validators.minLength(1), Validators.required])],
      middlename: ['', Validators.compose([Validators.maxLength(30)])],
      lastname: ['', Validators.compose([Validators.maxLength(30), Validators.required])],
      addAnotherApplicantItem: this.formBuilder.array([]),

    })

    this.change_log_string = [];

  }
  public validation_messages = {
    'address_type': [
      { type: 'required', message: 'address type is required.' },
      { type: 'maxLength', message: 'maxlength is 30' }
    ],
    'address_format': [
      { type: 'required', message: 'address format is required.' },
      { type: 'maxLength', message: 'maxlength is 30' }
    ],
    'street_type': [
      { type: 'required', message: 'street type is required.' },
      { type: 'maxLength', message: 'maxlength is 30' }
    ],
    'housing_situation': [
      { type: 'required', message: 'Housing Situation is required.' }
    ],
    'street_number': [
      { type: 'required', message: 'street number is required.' },
      { type: 'maxLength', message: 'maxlength is 30' }
    ],
    'street_name': [
      { type: 'required', message: 'street name is required.' },
      { type: 'maxLength', message: 'maxlength is 30' }
    ],
    'city': [
      { type: 'required', message: 'city is required.' },
      { type: 'maxLength', message: 'maxlength is 30' }
    ],
    'state': [
      { type: 'required', message: 'state is required.' },
      { type: 'maxLength', message: 'maxlength is 30' }
    ],
    'postcode': [
      { type: 'required', message: 'postcode is required.' },
      { type: 'minLength', message: 'postcode must be at least 4 digit long' },
      { type: 'maxLength', message: 'postcode must be at least 4 digit long' }
    ],
    'move_in_date': [
      { type: 'required', message: 'move in date is required.' },
    ]
  }

  public validation_messages_addition_applicant = {
    'addi_address_type': [
      { type: 'required', message: 'address type is required.' },
      { type: 'maxLength', message: 'maxlength is 30' }
    ],
    'addi_address_format': [
      { type: 'required', message: 'address format is required.' },
      { type: 'maxLength', message: 'maxlength is 30' }
    ],
    'addi_street_number': [
      { type: 'required', message: 'street number is required.' },
      { type: 'maxLength', message: 'maxlength is 30' }
    ],
    'addi_street_name': [
      { type: 'required', message: 'street name is required.' },
      { type: 'maxLength', message: 'maxlength is 30' }
    ],
    'addi_city': [
      { type: 'required', message: 'city is required.' },
      { type: 'maxLength', message: 'maxlength is 30' }
    ],
    'addi_postcode': [
      { type: 'required', message: 'postcode is required.' },
      { type: 'minLength', message: 'postcode must be at least 4 digit long' },
      { type: 'maxLength', message: 'postcode must be at least 4 digit long' }
    ],
    'addi_move_in_date': [
      { type: 'required', message: 'move_in_date is required.' },
    ]
  }
  //previous_state

  public validation_messages_primary_previous = {
    'previous_address_type': [
      { type: 'required', message: 'address type is required.' },
      { type: 'maxLength', message: 'maxlength is 30' }
    ],
    'previous_address_format': [
      { type: 'required', message: 'address format is required.' },
      { type: 'maxLength', message: 'maxlength is 30' }
    ],
    'previous_street_number': [
      { type: 'required', message: 'street number is required.' },
      { type: 'maxLength', message: 'maxlength is 30' }
    ],
    'previous_housing_situation': [
      { type: 'required', message: 'Housing Situation is required.' }
    ],
    'previous_state': [
      { type: 'required', message: 'state is required.' },
    ],
    'previous_street_name': [
      { type: 'required', message: 'street name is required.' },
      { type: 'maxLength', message: 'maxlength is 30' }
    ],
    'previous_street_type': [
      { type: 'required', message: 'street type is required.' },
      { type: 'maxLength', message: 'maxlength is 30' }
    ],
    'previous_city': [
      { type: 'required', message: 'city is required.' },
      { type: 'maxLength', message: 'maxlength is 30' }
    ],
    'previous_postcode': [
      { type: 'required', message: 'postcode is required.' },
      { type: 'minLength', message: 'postcode must be at least 4 digit long' },
      { type: 'maxLength', message: 'postcode must be at least 4 digit long' }
    ],
    'previous_move_in_date': [
      { type: 'required', message: 'move in date is required.' },
    ],
    'previous_move_out_date': [
      { type: 'required', message: 'move out date is required.' },
    ]
  }


  get formArrApplicantAddress() {
    return this.addreDetail.get('addAddressRelationshipItem') as FormArray;
  }

  additionalApplicant(): FormArray {
    return this.addreDetail.get('addAddressRelationshipItem') as FormArray;
  }


  get formPreviousAddress() {
    return this.addreDetail.get('addPreviousAddressItem') as FormArray;
  }


  ngAfterViewInit() {
    this.getPlaceAutocomplete();

  }

  getPlaceAutocomplete() {

    const autocomplete = new google.maps.places.Autocomplete(this.addresstext.nativeElement,
      {
        componentRestrictions: { country: 'AU' }
      });
    google.maps.event.addListener(autocomplete, 'place_changed', () => {
      const place = autocomplete.getPlace();
      let address_format = this.addreDetail.controls.address_format.value;
      let full_address = this.addreDetail.controls.full_address.value.split(' ');
      let full_address1 = full_address[0].split('/');
      if (full_address1.length == 1) {
        full_address1 = full_address[0].split('-');
      }
      for (let i = 0; i < place.address_components.length; i++) {

        this.new_val = '';
        this.old_val = '';

        if (place.address_components[i].types[0] == "street_number") {

          if (place.address_components[i].long_name.search('/') >= 0 || place.address_components[i].long_name.search('-') >= 0) {
            this.addreDetail.controls.street_number.setValue(place.address_components[i].long_name);
          } else if (full_address1.length > 1) {
            if (address_format == 'nonStandard') {
              this.addreDetail.controls.street_number.setValue(full_address[0]);
              this.addreDetail.controls.unit_number.setValue(full_address1[0]);
            } else {
              this.addreDetail.controls.street_number.setValue(full_address[0]);
              this.addreDetail.controls.unit_number.setValue(full_address1[0]);
            }
          } else {
            this.addreDetail.controls.street_number.setValue(place.address_components[i].long_name);
          }


          if (this.applicant_details !== undefined) {
            this.old_val = (this.applicant_details.street_number == undefined) ? '' : this.applicant_details.street_number;
            this.new_val = place.address_components[i].long_name;
          }


          if (this.new_val != this.old_val) {

            this.change_log_string.push({ 'property': 'Street Number', 'old_value': this.old_val, 'new_value': this.new_val });
          }
        }
        if (place.address_components[i].types[0] == "route") {
          let get_route = place.address_components[i].long_name;
          let type = place.address_components[i].long_name.split(" ");
          let typeName = type[type.length - 1];
          let get_street_name = get_route.split(" " + typeName).join("");
          this.addreDetail.controls.street_name.setValue(get_street_name);
          this.addreDetail.controls.street_type.setValue(typeName.toUpperCase());
          if (this.applicant_details !== undefined) {
            this.old_val = (this.applicant_details.street_name == undefined) ? '' : this.applicant_details.street_name;
          }

          this.new_val = get_street_name;
          if (this.new_val != this.old_val) {

            this.change_log_string.push({ 'property': 'Street Name', 'old_value': this.old_val, 'new_value': this.new_val });
          }
          if (this.applicant_details !== undefined) {
            this.old_val = (this.applicant_details.street_type == undefined) ? '' : this.applicant_details.street_type;
          }

          this.new_val = typeName.toUpperCase();
          if (this.new_val != this.old_val) {

            this.change_log_string.push({ 'property': 'Street Type', 'old_value': this.old_val, 'new_value': this.new_val });
          }

        }
        if (place.address_components[i].types[0] == "locality") {
          this.addreDetail.controls.city.setValue(place.address_components[i].long_name);
          if (this.applicant_details !== undefined) {
            this.old_val = (this.applicant_details.city == undefined) ? '' : this.applicant_details.city;
          }

          this.new_val = place.address_components[i].long_name;

          if (this.new_val != this.old_val) {

            this.change_log_string.push({ 'property': 'City', 'old_value': this.old_val, 'new_value': this.new_val });
          }
        }
        if (place.address_components[i].types[0] == "administrative_area_level_1") {
          this.addreDetail.controls.state.setValue(place.address_components[i].short_name);
          if (this.applicant_details !== undefined) {
            this.old_val = (this.applicant_details.state == undefined) ? '' : this.applicant_details.state;
          }

          this.new_val = place.address_components[i].short_name;

          if (this.new_val != this.old_val) {

            this.change_log_string.push({ 'property': 'State', 'old_value': this.old_val, 'new_value': this.new_val });
          }
        }
        if (place.address_components[i].types[0] == "country") {
          this.addreDetail.controls.country.setValue(place.address_components[i].long_name);
          if (this.applicant_details !== undefined) {
            this.old_val = (this.applicant_details.country == undefined) ? '' : this.applicant_details.country;
          }

          this.new_val = place.address_components[i].long_name;

          if (this.new_val != this.old_val) {

            this.change_log_string.push({ 'property': 'Country', 'old_value': this.old_val, 'new_value': this.new_val });
          }
        }
        if (place.address_components[i].types[0] == "postal_code") {
          this.addreDetail.controls.postcode.setValue(place.address_components[i].long_name);
          if (this.applicant_details !== undefined) {
            this.old_val = (this.applicant_details.postcode == undefined) ? '' : this.applicant_details.postcode;
          }

          this.new_val = place.address_components[i].long_name;

          if (this.new_val != this.old_val) {

            this.change_log_string.push({ 'property': 'Postcode', 'old_value': this.old_val, 'new_value': this.new_val });
          }
        }
      }

    });
  }



  addPreviousAddress(date) {
    this.formPreviousAddress.push(this.initaddPreviousAddress(date));
    this.indexx = this.formPreviousAddress.length - 1;

  }

  addAnotherApplicant(index) {
    this.primaryApplicantdata.push(this.initaddAnotherApplicant2());
    this.formArrApplicantAddress.push(this.initItemApplicantAddress(index));

    this.formArrApplicantAddress.at(index).get('addi_city').clearValidators();
    this.formArrApplicantAddress.at(index).get('addi_city').updateValueAndValidity();

    this.formArrApplicantAddress.at(index).get('addi_move_in_date').clearValidators();
    this.formArrApplicantAddress.at(index).get('addi_move_in_date').updateValueAndValidity();

    this.formArrApplicantAddress.at(index).get('addi_postcode').clearValidators();
    this.formArrApplicantAddress.at(index).get('addi_postcode').updateValueAndValidity();

    this.formArrApplicantAddress.at(index).get('addi_street_name').clearValidators();
    this.formArrApplicantAddress.at(index).get('addi_street_name').updateValueAndValidity();

    this.formArrApplicantAddress.at(index).get('addi_street_number').clearValidators();
    this.formArrApplicantAddress.at(index).get('addi_street_number').updateValueAndValidity();

    this.formArrApplicantAddress.at(index).get('addi_street_type').clearValidators();
    this.formArrApplicantAddress.at(index).get('addi_street_type').updateValueAndValidity();


    console.log(this.addreDetail);
  }

  initaddPreviousAddressLoad(data) {
    return this.formBuilder.group({

      previous_address_type: [data.address_type, Validators.compose([Validators.maxLength(30), Validators.required])],
      previous_address_format: [data.address_format, Validators.compose([Validators.maxLength(30), Validators.required])],
      previous_full_address: [''],
      previous_floor_number: [data.floor_number, Validators.compose([Validators.maxLength(30)])],
      previous_unit_number: [data.unit_number, Validators.compose([Validators.maxLength(30)])],
      previous_building_name: [data.building_name, Validators.compose([Validators.maxLength(30)])],
      previous_poboxlabel: [data.poboxlabel, Validators.compose([Validators.maxLength(30)])],
      previous_street_number: [data.street_number, Validators.compose([Validators.maxLength(30), Validators.required])],
      previous_street_name: [data.street_name, Validators.compose([Validators.maxLength(30), Validators.required])],
      previous_street_type: [data.street_type, Validators.compose([Validators.maxLength(30), Validators.required])],
      previous_city: [data.city, Validators.compose([Validators.maxLength(30), Validators.required])],
      previous_state: [data.state, Validators.compose([Validators.maxLength(30),Validators.required])],
      previous_postcode: [data.postcode, Validators.compose([Validators.maxLength(30), Validators.required])],
      previous_country: [data.country, Validators.compose([Validators.maxLength(30), Validators.required])],
      previous_housing_situation: [data.housing_situation,[Validators.required]],
      previous_move_in_date: [data.move_in_date, Validators.compose([Validators.maxLength(30), Validators.required])],
      previous_move_out_date: [data.move_out_date, Validators.compose([Validators.maxLength(30), Validators.required])],
      deleted: [0]
    });
  }

  initaddRelationAddressLoad(data) {
    return this.formBuilder.group({

      previous_address_type: [data.address_type, Validators.compose([Validators.maxLength(30), Validators.required])],
      previous_address_format: [data.address_format, Validators.compose([Validators.maxLength(30), Validators.required])],
      previous_full_address: [''],
      previous_floor_number: [data.floor_number, Validators.compose([Validators.maxLength(30)])],
      previous_unit_number: [data.unit_number, Validators.compose([Validators.maxLength(30)])],
      previous_building_name: [data.building_name, Validators.compose([Validators.maxLength(30)])],
      previous_poboxlabel: [data.poboxlabel, Validators.compose([Validators.maxLength(30)])],
      previous_street_number: [data.street_number, Validators.compose([Validators.maxLength(30), Validators.required])],
      previous_street_name: [data.street_name, Validators.compose([Validators.maxLength(30), Validators.required])],
      previous_street_type: [data.street_type, Validators.compose([Validators.maxLength(30), Validators.required])],
      previous_city: [data.city, Validators.compose([Validators.maxLength(30), Validators.required])],
      previous_state: [data.state, Validators.compose([Validators.maxLength(30)])],
      previous_postcode: [data.postcode, Validators.compose([Validators.maxLength(30), Validators.required])],
      previous_country: [data.country, Validators.compose([Validators.maxLength(30), Validators.required])],
      previous_housing_situation: [data.housing_situation],
      previous_move_in_date: [data.move_in_date, Validators.compose([Validators.maxLength(30), Validators.required])],
      previous_move_out_date: [data.move_out_date, Validators.compose([Validators.maxLength(30), Validators.required])],
      deleted: [0]
    });
  }

  getUserData(e) {

    console.log(e.contact_details.address);
    debugger;

       while ((<FormArray>this.addreDetail.get('addPreviousAddressItem')).length !== 0) {
          (<FormArray>this.addreDetail.get('addPreviousAddressItem')).removeAt(0);
        }

    if(e.contact_details.address) {
      e.contact_details.address.forEach((element, i) => {
        if (element.type === "current") {

          if(element.address_format == '') {

            this.addreDetail.controls.address_format.setValue('standard');
          }
          else {
            this.addreDetail.controls.address_format.setValue(element.address_format);
          }

          if(element.address_type == '') {
            //console.lo
            this.addreDetail.controls.address_type.setValue('Home');
          }
          else {
            this.addreDetail.controls.address_type.setValue(element.address_type);
          }

          if(element.housing_situation == '') {
            this.addreDetail.controls.housing_situation.setValue('');
          }
          else {
            this.addreDetail.controls.housing_situation.setValue(element.housing_situation);
            if(element.housing_situation == "Own Home") {
              console.log('its working');
              this.housingsituation_evtemit1.emit();
            }
          }


          this.addreDetail.controls.building_name.setValue(element.building_name);
          this.addreDetail.controls.city.setValue(element.city);
          this.addreDetail.controls.country.setValue(element.country);
          this.addreDetail.controls.floor_number.setValue(element.floor_number);
         // this.addreDetail.controls.housing_situation.setValue(element.housing_situation);
          this.addreDetail.controls.move_in_date.setValue(element.move_in_date);
          this.addreDetail.controls.poboxlabel.setValue(element.poboxlabel);
          this.addreDetail.controls.postcode.setValue(element.postcode);
          this.addreDetail.controls.state.setValue(element.state);
          this.addreDetail.controls.street_name.setValue(element.street_name);
          this.addreDetail.controls.street_number.setValue(element.street_number);
          this.addreDetail.controls.street_type.setValue(element.street_type);
          this.addreDetail.controls.unit_number.setValue(element.unit_number);
        }
        else {

          //(<FormArray>this.addreDetail.get('addPreviousAddressItem')).reset();


          (<FormArray>this.addreDetail.get('addPreviousAddressItem'))
            .push(this.initaddPreviousAddressLoad(e["contact_details"].address[i]));
        }
      });
    }


    console.log(this.addreDetail);

    this.primaryData.controls.firstname.setValue(e.user_data.firstname);
    this.primaryData.controls.lastname.setValue(e.user_data.lastname);

  }

  getAdditionalApplicantUserData(data, index) {

    // while ((<FormArray>(<FormArray>this.addreDetail.get('addAddressRelationshipItem')).at(index).get('addPAddressRelationshipItem')).length !== 0) {
    //   (<FormArray>(<FormArray>this.addreDetail.get('addAddressRelationshipItem')).at(index).get('addPAddressRelationshipItem')).removeAt(0);
    // }
    debugger;

    let anotherApplicantAddressFormGroup = <FormGroup>this.addreDetail.controls['addAddressRelationshipItem']['controls'][index];

    data["contact_details"].address.forEach((element, i) => {

      if (element.type === 'current') {
        anotherApplicantAddressFormGroup.controls.addi_address_type.setValue(element.address_type);
        anotherApplicantAddressFormGroup.controls.addi_address_format.setValue(element.address_format);
        anotherApplicantAddressFormGroup.controls.addi_full_address.setValue("kolkata shs");
        anotherApplicantAddressFormGroup.controls.addi_city.setValue(element.city);
        anotherApplicantAddressFormGroup.controls.addi_state.setValue(element.state);
        anotherApplicantAddressFormGroup.controls.addi_postcode.setValue(element.postcode);
        anotherApplicantAddressFormGroup.controls.addi_country.setValue(element.country);
        anotherApplicantAddressFormGroup.controls.addi_housing_situation.setValue(element.housing_situation);
        anotherApplicantAddressFormGroup.controls.addi_move_in_date.setValue(element.move_in_date);
      }
      else {


          this.additionalPrevAddress(i).push(this.initItemRowsPreviousAddress3(data["contact_details"].address[i]));

      }
    });
  }

  getValue() {
    this.getAddressFormData_evtemit.emit({ addressDetailFormValue: this.addreDetail.value,
       addressDetailFormValid: this.addreDetail.valid,addressDetailForm:this.addreDetail});
  }

  initaddPreviousAddress(date) {
    return this.formBuilder.group({

      previous_address_type: ['Home', Validators.compose([Validators.maxLength(30), Validators.required])],
      previous_address_format: ['standard', Validators.compose([Validators.maxLength(30), Validators.required])],
      previous_full_address: [''],
      previous_floor_number: ['', Validators.compose([Validators.maxLength(30)])],
      previous_unit_number: ['', Validators.compose([Validators.maxLength(30)])],
      previous_building_name: ['', Validators.compose([Validators.maxLength(30)])],
      previous_poboxlabel: ['', Validators.compose([Validators.maxLength(30)])],
      previous_street_number: ['', Validators.compose([Validators.maxLength(30), Validators.required])],
      previous_street_name: ['', Validators.compose([Validators.maxLength(30), Validators.required])],
      previous_street_type: ['', Validators.compose([Validators.maxLength(30), Validators.required])],
      previous_city: ['', Validators.compose([Validators.maxLength(30)])],
      previous_state: ['', Validators.compose([Validators.maxLength(30),Validators.required])],
      previous_postcode: ['', Validators.compose([Validators.maxLength(30), Validators.required])],
      previous_country: ['Australia', Validators.compose([Validators.maxLength(30)])],
      previous_housing_situation: ['',[Validators.required]],
      previous_move_in_date: ['', Validators.compose([Validators.maxLength(30), Validators.required])],
      previous_move_out_date: [date, Validators.compose([Validators.maxLength(30),Validators.required])],
      deleted: [0]
    });
  }

  initItemApplicantAddress(index) {

    return this.formBuilder.group({

      addi_same_as_primary: ['true'],
      addi_address_type: ['Home', Validators.compose([Validators.maxLength(30),Validators.required])],
      addi_address_format: ['standard', Validators.compose([Validators.maxLength(30),Validators.required])],
      addi_full_address: ['', Validators.compose([Validators.maxLength(30)])],
      addi_floor_number: ['', Validators.compose([Validators.maxLength(30)])],
      addi_unit_number: ['', Validators.compose([Validators.maxLength(30)])],
      addi_building_name: ['', Validators.compose([Validators.maxLength(200)])],
      addi_street_number: ['', Validators.compose([Validators.maxLength(30),Validators.required])],
      addi_street_name: ['', Validators.compose([Validators.maxLength(30),Validators.required])],
      addi_street_type: ['', Validators.compose([Validators.maxLength(30),Validators.required])],
      addi_poboxlabel: ['', Validators.compose([Validators.maxLength(30)])],
      addi_city: ['', Validators.compose([Validators.maxLength(30),Validators.required])],
      addi_state: ['', Validators.compose([Validators.maxLength(30)])],
      addi_postcode: ['', Validators.compose([Validators.maxLength(30),Validators.required])],
      addi_country: ['Australia', Validators.compose([Validators.maxLength(30),Validators.required])],
      addi_housing_situation: ['', Validators.compose([Validators.maxLength(30)])],
      addi_move_out_date: ['', Validators.compose([Validators.maxLength(30)])],
      addi_move_in_date: ['', Validators.compose([Validators.maxLength(30),Validators.required])],
      document_id: [''],
      deleted: [0],
      index: index,

      addPAddressRelationshipItem: this.formBuilder.array([])
    });
  }

  initItemApplicantAddress2(formObj,index) {
    return this.formBuilder.group({
      addi_same_as_primary: [formObj.same_as_primary],
      addi_address_type: [formObj.address_type, Validators.compose([Validators.maxLength(30),Validators.required])],
      addi_address_format: [formObj.address_format, Validators.compose([Validators.maxLength(30),Validators.required])],
      addi_full_address: ['', Validators.compose([Validators.maxLength(30)])],
      addi_floor_number: [formObj.floor_number, Validators.compose([Validators.maxLength(30)])],
      addi_unit_number: [formObj.unit_number, Validators.compose([Validators.maxLength(30)])],
      addi_building_name: [formObj.building_name, Validators.compose([Validators.maxLength(200)])],
      addi_street_number: [formObj.street_number, Validators.compose([Validators.maxLength(30),Validators.required])],
      addi_street_name: [formObj.street_name, Validators.compose([Validators.maxLength(30),Validators.required])],
      addi_street_type: [formObj.street_type, Validators.compose([Validators.maxLength(30),Validators.required])],
      addi_poboxlabel: [formObj.poboxlabel, Validators.compose([Validators.maxLength(30)])],
      addi_city: [formObj.city, Validators.compose([Validators.maxLength(30),Validators.required])],
      addi_state: [formObj.state, Validators.compose([Validators.maxLength(30)])],
      addi_postcode: [formObj.postcode, Validators.compose([Validators.maxLength(30),Validators.required])],
      addi_country: [formObj.country, Validators.compose([Validators.maxLength(30),Validators.required])],
      addi_housing_situation: [formObj.housing_situation, Validators.compose([Validators.maxLength(30)])],
      addi_move_out_date: ['', Validators.compose([Validators.maxLength(30)])],
      addi_move_in_date: [formObj.move_in_date, Validators.compose([Validators.maxLength(30),Validators.required])],
      document_id: [''],
      deleted: [''],
      index: index,
      addPAddressRelationshipItem: this.formBuilder.array([])
    });
  }

  addAddressRelationship(index) {
    debugger;
    this.indexOf_additionalApplicant_previousAddress=index;
    this.formArrApplicantAddress.push(this.initItemApplicantAddress(index));
    this.primaryApplicantdata.push(this.initaddAnotherApplicant2());

    this.addRemoveValidation(true, index-1);
    // console.log(index);
    // console.log(this.addreDetail);
    // console.log(this.formArrApplicantAddress);



  }
  addressOfApplicant(event, index) {
    this.showPrimaryApplicantAddress = 0;
    this.showAdditional_address = index;

  }
  showApplicant(index) {
    this.showPrimaryApplicantAddress = 0;
    this.showAdditional_address = index;

  }
  primaryApplicantAddress(event) {

    this.showPrimaryApplicantAddress = 1;
    this.showAdditional_address = -1;

  }
  showprimaryApplicantAddress() {
    this.showPrimaryApplicantAddress = 1;
    this.showAdditional_address = -1;

  }
  ngOnInit() {

    this.DataService.currentAddAnotherApplicant.subscribe(formApplicant => {

      if (formApplicant) {

        this.formApplicant = formApplicant;
        this.addAddressRelationship(this.formApplicant.length)

      }

    });

  }

  ngOnChanges() {


  }

  initItemRowsPreviousAddress3(formObj) {

    return this.formBuilder.group({
      addi_same_as_primary: ['true'],
      addi_address_type: [formObj.address_type, Validators.compose([Validators.maxLength(30),Validators.required])],
      addi_address_format: [formObj.address_format, Validators.compose([Validators.maxLength(30),Validators.required])],
      addi_full_address: ['', Validators.compose([Validators.maxLength(30)])],
      addi_floor_number: [formObj.floor_number, Validators.compose([Validators.maxLength(30)])],
      addi_unit_number: [formObj.unit_number, Validators.compose([Validators.maxLength(30)])],
      addi_building_name: [formObj.building_name, Validators.compose([Validators.maxLength(200)])],
      addi_street_number: [formObj.street_number, Validators.compose([Validators.maxLength(30),Validators.required])],
      addi_street_name: [formObj.street_name, Validators.compose([Validators.maxLength(30),Validators.required])],
      addi_street_type: [formObj.street_type, Validators.compose([Validators.maxLength(30),Validators.required])],
      addi_poboxlabel: [formObj.poboxlabel, Validators.compose([Validators.maxLength(30)])],
      addi_city: [formObj.city, Validators.compose([Validators.maxLength(30)])],
      addi_state: [formObj.state, Validators.compose([Validators.maxLength(30)])],
      addi_postcode: [formObj.postcode, Validators.compose([Validators.maxLength(30),Validators.required])],
      addi_country: [formObj.country, Validators.compose([Validators.maxLength(30),Validators.required])],
      addi_housing_situation: [formObj.housing_situation, Validators.compose([Validators.maxLength(30)])],
      addi_move_out_date: [formObj.move_out_date, Validators.compose([Validators.maxLength(30),Validators.required])],
      addi_move_in_date: [formObj.move_in_date, Validators.compose([Validators.maxLength(30),Validators.required])],
      document_id: [''],
      deleted: [''],


    });
  }
  changeLog(event, index: any) {

  }

  collectLogData(event, type, index) {

    this.new_val = event.target.value;

    this.old_val = '';
    var property = '';

    if (type == 'address_type') {
      this.old_val = (this.applicant_details.address_type == undefined) ? '' : this.applicant_details.address_type;
      property = 'Address Type';
    }
    if (type == 'street_type') {
      this.old_val = (this.applicant_details.street_type == undefined) ? '' : this.applicant_details.street_type;
      property = 'Street Type';
    }
    if (type == 'state') {
      this.old_val = (this.applicant_details.state == undefined) ? '' : this.applicant_details.state;
      property = 'State';
    }
    if (type == 'country') {
      this.old_val = (this.applicant_details.country == undefined) ? '' : this.applicant_details.country;
      property = 'Country';
    }
    if (type == 'housing_situation') {
      this.old_val = (this.applicant_details.housing_situation == undefined) ? '' : this.applicant_details.housing_situation;
      property = 'Housing Situation';
    }
    if (type == 'move_in_date') {
      this.old_val = (this.applicant_details.move_in_date == undefined) ? '' : this.applicant_details.move_in_date;
      property = 'Move in Date';
    }
    if (type == 'date_of_birth') {
      this.old_val = (this.applicant_details.date_of_birth == undefined) ? '' : this.applicant_details.date_of_birth;
      property = 'Date of Birth';
    }

    if (this.new_val != this.old_val) {
      this.change_log_string.push({ 'property': property, 'old_value': this.old_val, 'new_value': this.new_val, 'index': index, 'index2': index });
    }
  }

  removePreviousAddress(key) {
    if (key > -1) {
      for (var i = this.formPreviousAddress.length; i > 0; i--) {
        if (i > key) {
          this.formPreviousAddress.removeAt(i);
        }
      }
    } else {
      this.formPreviousAddress.removeAt(key);
    }

  }


  updateSecondaryAddress(inputText, index) {

    let addressInput = document.getElementById("additional_address_" + index);
    let autocomplete = new google.maps.places.Autocomplete(addressInput, {
      componentRestrictions: { country: 'AU' }
    });
    autocomplete.inputId = addressInput;
    google.maps.event.addListener(autocomplete, 'place_changed', () => {
      const place = autocomplete.getPlace();
      let address_format = this.addreDetail.value.addAddressRelationshipItem[index].addi_address_format;
      let full_address = this.addreDetail.value.addAddressRelationshipItem[index].addi_full_address.split(' ');
      let full_address1 = full_address[0].split('/');
      if (full_address1.length == 1) {
        full_address1 = full_address[0].split('-');
      }
      for (let i = 0; i < place.address_components.length; i++) {
        if (place.address_components[i].types[0] == "street_number") {
          if (place.address_components[i].long_name.search('/') >= 0 || place.address_components[i].long_name.search('-') >= 0) {
            this.addreDetail.controls['addAddressRelationshipItem']['controls'][index].controls.addi_street_number.setValue(place.address_components[i].long_name);
          } else if (full_address1.length > 1) {
            if (address_format == 'nonStandard') {
              this.addreDetail.controls['addAddressRelationshipItem']['controls'][index].controls.addi_street_number.setValue(full_address[0]);
              this.addreDetail.controls['addAddressRelationshipItem']['controls'][index].controls.addi_unit_number.setValue(full_address1[0]);
            } else {
              this.addreDetail.controls['addAddressRelationshipItem']['controls'][index].controls.addi_street_number.setValue(full_address[0]);
              this.addreDetail.controls['addAddressRelationshipItem']['controls'][index].controls.addi_unit_number.setValue(full_address1[0]);
            }
          } else {
            this.addreDetail.controls['addAddressRelationshipItem']['controls'][index].controls.addi_street_number.setValue(place.address_components[i].long_name);
          }
        }
        if (place.address_components[i].types[0] == "route") {
          let get_route = place.address_components[i].long_name;
          let type = place.address_components[i].long_name.split(" ");
          let typeName = type[type.length - 1];
          let get_street_name = get_route.split(" " + typeName).join("");
          this.addreDetail.controls['addAddressRelationshipItem']['controls'][index].controls.addi_street_name.setValue(get_street_name);
          this.addreDetail.controls['addAddressRelationshipItem']['controls'][index].controls.addi_street_type.setValue(typeName.toUpperCase());
        }
        if (place.address_components[i].types[0] == "locality") {
          this.addreDetail.controls['addAddressRelationshipItem']['controls'][index].controls.addi_city.setValue(place.address_components[i].long_name);
        }
        if (place.address_components[i].types[0] == "administrative_area_level_1") {
          this.addreDetail.controls['addAddressRelationshipItem']['controls'][index].controls.addi_state.setValue(place.address_components[i].short_name);
        }
        if (place.address_components[i].types[0] == "country") {
          this.addreDetail.controls['addAddressRelationshipItem']['controls'][index].controls.addi_country.setValue(place.address_components[i].long_name);
        }
        if (place.address_components[i].types[0] == "postal_code") {
          this.addreDetail.controls['addAddressRelationshipItem']['controls'][index].controls.addi_postcode.setValue(place.address_components[i].long_name);
        }
      }

    });

    let currentadditionAddressFormGroup:FormGroup=this.addreDetail.controls['addAddressRelationshipItem']['controls'][index] as FormGroup;

    currentadditionAddressFormGroup.get('addi_address_type').markAsTouched();

    currentadditionAddressFormGroup.get('addi_address_format').markAsTouched();

    currentadditionAddressFormGroup.get('addi_full_address').markAsTouched();

    currentadditionAddressFormGroup.get('addi_floor_number').markAsTouched();

    currentadditionAddressFormGroup.get('addi_unit_number').markAsTouched();

    currentadditionAddressFormGroup.get('addi_building_name').markAsTouched();

    currentadditionAddressFormGroup.get('addi_street_number').markAsTouched();

    currentadditionAddressFormGroup.get('addi_street_name').markAsTouched();

    currentadditionAddressFormGroup.get('addi_street_type').markAsTouched();

    currentadditionAddressFormGroup.get('addi_poboxlabel').markAsTouched();

    currentadditionAddressFormGroup.get('addi_city').markAsTouched();

    currentadditionAddressFormGroup.get('addi_state').markAsTouched();

    currentadditionAddressFormGroup.get('addi_postcode').markAsTouched();

    currentadditionAddressFormGroup.get('addi_country').markAsTouched();

    currentadditionAddressFormGroup.get('addi_housing_situation').markAsTouched();

    currentadditionAddressFormGroup.get('addi_move_out_date').markAsTouched();

    currentadditionAddressFormGroup.get('addi_move_in_date').markAsTouched();


  }
  updateSecondaryPrevAddress(inputText, index, prevIndex) {

    let addressInput = document.getElementById("additional_prevaddress_" + prevIndex);

    let autocomplete = new google.maps.places.Autocomplete(addressInput, {
      componentRestrictions: { country: 'AU' }
    });
    autocomplete.inputId = addressInput;
    google.maps.event.addListener(autocomplete, 'place_changed', () => {
      const place = autocomplete.getPlace();
      let address_format = this.addreDetail.controls.addAddressRelationshipItem.value[index].addPAddressRelationshipItem[prevIndex].addi_address_format;
      let full_address = this.addreDetail.controls.addAddressRelationshipItem.value[index].addPAddressRelationshipItem[prevIndex].addi_full_address.split(' ');
      let full_address1 = full_address[0].split('/');
      if (full_address1.length == 1) {
        full_address1 = full_address[0].split('-');
      }
      for (let i = 0; i < place.address_components.length; i++) {
        if (place.address_components[i].types[0] == "street_number") {
          if (place.address_components[i].long_name.search('/') >= 0 || place.address_components[i].long_name.search('-') >= 0) {
            this.addreDetail.controls['addAddressRelationshipItem']['controls'][index].controls.addPAddressRelationshipItem.controls[prevIndex].addi_street_number.setValue(place.address_components[i].long_name);
          } else if (full_address1.length > 1) {
            if (address_format == 'nonStandard') {
              this.addreDetail.controls['addAddressRelationshipItem']['controls'][index].controls.addPAddressRelationshipItem.controls[prevIndex].controls.addi_street_number.setValue(full_address[0]);
              this.addreDetail.controls['addAddressRelationshipItem']['controls'][index].controls.addPAddressRelationshipItem.controls[prevIndex].controls.addi_unit_number.setValue(full_address1[0]);
            } else {
              this.addreDetail.controls['addAddressRelationshipItem']['controls'][index].controls.addPAddressRelationshipItem.controls[prevIndex].controls.addi_street_number.setValue(full_address[0]);
              this.addreDetail.controls['addAddressRelationshipItem']['controls'][index].controls.addPAddressRelationshipItem.controls[prevIndex].controls.addi_unit_number.setValue(full_address1[0]);
            }
          } else {
            this.addreDetail.controls['addAddressRelationshipItem']['controls'][index].controls.addPAddressRelationshipItem.controls[prevIndex].controls.addi_street_number.setValue(place.address_components[i].long_name);
          }
        }
        if (place.address_components[i].types[0] == "route") {
          let get_route = place.address_components[i].long_name;
          let type = place.address_components[i].long_name.split(" ");
          let typeName = type[type.length - 1];
          let get_street_name = get_route.split(" " + typeName).join("");
          this.addreDetail.controls['addAddressRelationshipItem']['controls'][index].controls.addPAddressRelationshipItem.controls[prevIndex].controls.addi_street_name.setValue(get_street_name);
          this.addreDetail.controls['addAddressRelationshipItem']['controls'][index].controls.addPAddressRelationshipItem.controls[prevIndex].controls.addi_street_type.setValue(typeName.toUpperCase());
        }
        if (place.address_components[i].types[0] == "locality") {
          this.addreDetail.controls['addAddressRelationshipItem']['controls'][index].controls.addPAddressRelationshipItem.controls[prevIndex].controls.addi_city.setValue(place.address_components[i].long_name);
        }
        if (place.address_components[i].types[0] == "administrative_area_level_1") {
          this.addreDetail.controls['addAddressRelationshipItem']['controls'][index].controls.addPAddressRelationshipItem.controls[prevIndex].controls.addi_state.setValue(place.address_components[i].short_name);
        }
        if (place.address_components[i].types[0] == "country") {
          this.addreDetail.controls['addAddressRelationshipItem']['controls'][index].controls.addPAddressRelationshipItem.controls[prevIndex].controls.addi_country.setValue(place.address_components[i].long_name);
        }
        if (place.address_components[i].types[0] == "postal_code") {
          this.addreDetail.controls['addAddressRelationshipItem']['controls'][index].controls.addPAddressRelationshipItem.controls[prevIndex].controls.addi_postcode.setValue(place.address_components[i].long_name);
        }
      }

    });
    this.addreDetail.controls['addAddressRelationshipItem']['controls'][index].controls.addPAddressRelationshipItem.controls[prevIndex].controls.addi_address_type.markAsTouched();

    this.addreDetail.controls['addAddressRelationshipItem']['controls'][index].controls.addPAddressRelationshipItem.controls[prevIndex].controls.addi_address_format.markAsTouched();

    this.addreDetail.controls['addAddressRelationshipItem']['controls'][index].controls.addPAddressRelationshipItem.controls[prevIndex].controls.addi_full_address.markAsTouched();

    this.addreDetail.controls['addAddressRelationshipItem']['controls'][index].controls.addPAddressRelationshipItem.controls[prevIndex].controls.addi_floor_number.markAsTouched();

    this.addreDetail.controls['addAddressRelationshipItem']['controls'][index].controls.addPAddressRelationshipItem.controls[prevIndex].controls.addi_unit_number.markAsTouched();

    this.addreDetail.controls['addAddressRelationshipItem']['controls'][index].controls.addPAddressRelationshipItem.controls[prevIndex].controls.addi_building_name.markAsTouched();

    this.addreDetail.controls['addAddressRelationshipItem']['controls'][index].controls.addPAddressRelationshipItem.controls[prevIndex].controls.addi_street_number.markAsTouched();

    this.addreDetail.controls['addAddressRelationshipItem']['controls'][index].controls.addPAddressRelationshipItem.controls[prevIndex].controls.addi_street_name.markAsTouched();

    this.addreDetail.controls['addAddressRelationshipItem']['controls'][index].controls.addPAddressRelationshipItem.controls[prevIndex].controls.addi_street_type.markAsTouched();

    this.addreDetail.controls['addAddressRelationshipItem']['controls'][index].controls.addPAddressRelationshipItem.controls[prevIndex].controls.addi_poboxlabel.markAsTouched();

    this.addreDetail.controls['addAddressRelationshipItem']['controls'][index].controls.addPAddressRelationshipItem.controls[prevIndex].controls.addi_city.markAsTouched();

    this.addreDetail.controls['addAddressRelationshipItem']['controls'][index].controls.addPAddressRelationshipItem.controls[prevIndex].controls.addi_state.markAsTouched();

    this.addreDetail.controls['addAddressRelationshipItem']['controls'][index].controls.addPAddressRelationshipItem.controls[prevIndex].controls.addi_postcode.markAsTouched();

    this.addreDetail.controls['addAddressRelationshipItem']['controls'][index].controls.addPAddressRelationshipItem.controls[prevIndex].controls.addi_country.markAsTouched();

    this.addreDetail.controls['addAddressRelationshipItem']['controls'][index].controls.addPAddressRelationshipItem.controls[prevIndex].controls.addi_move_out_date.markAsTouched();

    this.addreDetail.controls['addAddressRelationshipItem']['controls'][index].controls.addPAddressRelationshipItem.controls[prevIndex].controls.addi_move_in_date.markAsTouched();

  }
  updatePreviousAddress(inputText, index, type) {

    debugger;
    let addressInput = document.getElementById("address_" + index);
    let autocomplete = new google.maps.places.Autocomplete(addressInput, {
      componentRestrictions: { country: 'AU' }
    });
    autocomplete.inputId = addressInput;
    google.maps.event.addListener(autocomplete, 'place_changed', () => {
      const place = autocomplete.getPlace();
      let address_format = this.addreDetail.controls['addPreviousAddressItem']['controls'][index].controls.previous_address_format.value;
      let full_address = this.addreDetail.controls['addPreviousAddressItem']['controls'][index].controls.previous_full_address.value.split(' ');
      let full_address1 = full_address[0].split('/');
      if (full_address1.length == 1) {
        full_address1 = full_address[0].split('-');
      }
      for (let i = 0; i < place.address_components.length; i++) {
        if (place.address_components[i].types[0] == "street_number") {
          if (place.address_components[i].long_name.search('/') >= 0 || place.address_components[i].long_name.search('-') >= 0) {
            this.addreDetail.controls['addPreviousAddressItem']['controls'][index].controls.previous_street_number.setValue(place.address_components[i].long_name);
          } else if (full_address1.length > 1) {
            if (address_format == 'nonStandard') {
              this.addreDetail.controls['addPreviousAddressItem']['controls'][index].controls.previous_street_number.setValue(full_address[0]);
              this.addreDetail.controls['addPreviousAddressItem']['controls'][index].controls.previous_unit_number.setValue(full_address1[0]);
            } else {
              this.addreDetail.controls['addPreviousAddressItem']['controls'][index].controls.previous_street_number.setValue(full_address[0]);
              this.addreDetail.controls['addPreviousAddressItem']['controls'][index].controls.previous_unit_number.setValue(full_address1[0]);
            }
          } else {
            this.addreDetail.controls['addPreviousAddressItem']['controls'][index].controls.previous_street_number.setValue(place.address_components[i].long_name);
          }
        }
        if (place.address_components[i].types[0] == "route") {
          let get_route = place.address_components[i].long_name;
          let type = place.address_components[i].long_name.split(" ");
          let typeName = type[type.length - 1];
          let get_street_name = get_route.split(" " + typeName).join("");
          this.addreDetail.controls['addPreviousAddressItem']['controls'][index].controls.previous_street_name.setValue(get_street_name);
          this.addreDetail.controls['addPreviousAddressItem']['controls'][index].controls.previous_street_type.setValue(typeName.toUpperCase());
        }
        if (place.address_components[i].types[0] == "locality") {
          this.addreDetail.controls['addPreviousAddressItem']['controls'][index].controls.previous_city.setValue(place.address_components[i].long_name);
        }
        if (place.address_components[i].types[0] == "administrative_area_level_1") {
          this.addreDetail.controls['addPreviousAddressItem']['controls'][index].controls.previous_state.setValue(place.address_components[i].short_name);
        }
        if (place.address_components[i].types[0] == "country") {
          this.addreDetail.controls['addPreviousAddressItem']['controls'][index].controls.previous_country.setValue(place.address_components[i].long_name);
        }
        if (place.address_components[i].types[0] == "postal_code") {
          this.addreDetail.controls['addPreviousAddressItem']['controls'][index].controls.previous_postcode.setValue(place.address_components[i].long_name);
        }
      }

    });
    this.addreDetail.controls['addPreviousAddressItem']['controls'][index].controls.previous_address_type.markAsTouched();

    this.addreDetail.controls['addPreviousAddressItem']['controls'][index].controls.previous_address_format.markAsTouched();

    this.addreDetail.controls['addPreviousAddressItem']['controls'][index].controls.previous_full_address.markAsTouched();

    this.addreDetail.controls['addPreviousAddressItem']['controls'][index].controls.previous_floor_number.markAsTouched();

    this.addreDetail.controls['addPreviousAddressItem']['controls'][index].controls.previous_unit_number.markAsTouched();

    this.addreDetail.controls['addPreviousAddressItem']['controls'][index].controls.previous_building_name.markAsTouched();

    this.addreDetail.controls['addPreviousAddressItem']['controls'][index].controls.previous_poboxlabel.markAsTouched();

    this.addreDetail.controls['addPreviousAddressItem']['controls'][index].controls.previous_street_number.markAsTouched();

    this.addreDetail.controls['addPreviousAddressItem']['controls'][index].controls.previous_street_name.markAsTouched();

    this.addreDetail.controls['addPreviousAddressItem']['controls'][index].controls.previous_street_type.markAsTouched();

    this.addreDetail.controls['addPreviousAddressItem']['controls'][index].controls.previous_city.markAsTouched();

    this.addreDetail.controls['addPreviousAddressItem']['controls'][index].controls.previous_state.markAsTouched();

    this.addreDetail.controls['addPreviousAddressItem']['controls'][index].controls.previous_postcode.markAsTouched();

    this.addreDetail.controls['addPreviousAddressItem']['controls'][index].controls.previous_country.markAsTouched();

    this.addreDetail.controls['addPreviousAddressItem']['controls'][index].controls.previous_move_in_date.markAsTouched();

    this.addreDetail.controls['addPreviousAddressItem']['controls'][index].controls.previous_move_out_date.markAsTouched();
  }

  getCurrentAddressDate(event, key, con_type, index) {

    var getDate = event.target.value;
    var datesplit = getDate.split("/");
    if (datesplit.length == 3) {
      var newDate = new Date().getTime()
      var oldDate = new Date(datesplit[2] + '-' + datesplit[1] + '-' + datesplit[0] + 'T00:00:00Z')
      oldDate.setMonth(oldDate.getMonth() + 36);
      var oldDate1 = oldDate.getTime();
      if (con_type == 'primary') {
        if (newDate > oldDate1) {
          this.removePreviousAddress(key)
        } else {
          if ((this.formPreviousAddress.length == 1 && key == "main")) {
          } else {
            if (this.formPreviousAddress.length == (key + 1)) {
              let date = this.addreDetail.controls.addPreviousAddressItem.value[key].previous_move_in_date;
              this.addPreviousAddress(date)
            } else if ((this.formPreviousAddress.length == 0 && key == "main")) {
              let date = this.addreDetail.controls.move_in_date.value;
              this.addPreviousAddress(date)
            }
          }
        }
      } else if (con_type == 'additional') {

        if (newDate > oldDate1) {
          this.removePreviousAddressRelationship1(key, index)
        } else {

          if ((this.additionalPrevAddress(index).length == 1 && key == "main")) {

          }
          else {

            if (this.additionalPrevAddress(index).length == (key + 1)) {


              this.addPreviousAddressRelationship1(index, getDate)
            } else if ((this.additionalPrevAddress(index).length == 0 && key == "main")) {

              this.addPreviousAddressRelationship1(index, getDate)
            }
          }


        }
      }
    }

    console.log(this.addreDetail);

  }

  additionalPrevAddress(appIndex: number): FormArray {
    return this.additionalApplicant().at(appIndex).get("addPAddressRelationshipItem") as FormArray
  }

  initItemRowsPreviousAddress(getdate) {
    return this.formBuilder.group({
      addi_same_as_primary: ['true'],
      addi_address_type: ['Home', Validators.compose([Validators.maxLength(30), Validators.required])],
      addi_address_format: ['standard', Validators.compose([Validators.maxLength(30), Validators.required])],
      addi_full_address: ['', Validators.compose([Validators.maxLength(30)])],
      addi_floor_number: ['', Validators.compose([Validators.maxLength(30)])],
      addi_unit_number: ['', Validators.compose([Validators.maxLength(30)])],
      addi_building_name: ['', Validators.compose([Validators.maxLength(200)])],
      addi_street_number: ['', Validators.compose([Validators.maxLength(30), Validators.required])],
      addi_street_name: ['', Validators.compose([Validators.maxLength(30), Validators.required])],
      addi_street_type: ['', Validators.compose([Validators.maxLength(30)])],
      addi_poboxlabel: ['', Validators.compose([Validators.maxLength(30)])],
      addi_city: ['', Validators.compose([Validators.maxLength(30), Validators.required])],
      addi_state: ['', Validators.compose([Validators.maxLength(30)])],
      addi_postcode: ['', Validators.compose([Validators.maxLength(30), Validators.required])],
      addi_country: ['Australia', Validators.compose([Validators.maxLength(30)])],
      // addi_housing_situation: ['',[Validators.required]],
      addi_housing_situation: [''],
      addi_move_out_date: [getdate, Validators.compose([Validators.maxLength(30), Validators.required])],
      addi_move_in_date: ['', Validators.compose([Validators.maxLength(30), Validators.required])],
      document_id: [''],
      deleted: [0]
    });
  }

  addPreviousAddressRelationship1(appIndex: number, getDate) {

    this.additionalPrevAddress(appIndex).push(this.initItemRowsPreviousAddress(getDate));

  }

  removePreviousAddressRelationship1(appIndex: number, AddIndex: number) {


    if (appIndex > -1) {
      for (var i = this.additionalPrevAddress(AddIndex).length; i > 0; i--) {
        if (i > appIndex) {
          this.additionalPrevAddress(AddIndex).removeAt(i);
        }
      }
    } else {

      this.additionalPrevAddress(AddIndex).removeAt(appIndex);
    }


  }







  public changeAddressFormat($event, index, types) {
    let streetNumber = this.addreDetail.get('street_number');
    let streetName = this.addreDetail.get('street_name');
    let streetType = this.addreDetail.get('street_type');
    if (types == 'primary_address') {
      this.address_format = $event;
      streetNumber = this.addreDetail.get('street_number');
      streetName = this.addreDetail.get('street_name');
      streetType = this.addreDetail.get('street_type');
    } else if (types == 'primary_previous') {
      streetNumber = this.addreDetail.controls.addPreviousAddressItem['controls'][index].get('previous_street_number');
      streetName = this.addreDetail.controls.addPreviousAddressItem['controls'][index].get('previous_street_name');
      streetType = this.addreDetail.controls.addPreviousAddressItem['controls'][index].get('previous_street_type');
    } else if (types == 'secondary_address') {
      streetNumber = this.addreDetail.controls.addAddressRelationshipItem['controls'][index].get('addi_street_number');
      streetName = this.addreDetail.controls.addAddressRelationshipItem['controls'][index].get('addi_street_name');
      streetType = this.addreDetail.controls.addAddressRelationshipItem['controls'][index].get('addi_street_type');
    }
    if ($event == 'nonStandard') {
      streetNumber.setValidators(Validators.required);
      streetName.setValidators(Validators.required);
      streetType.setValidators(Validators.required);
    } else if ($event == 'poBox') {
      streetNumber.setValidators(null);
      streetName.setValidators(null);
      streetType.setValidators(null);
    } else {
      streetNumber.setValidators(Validators.required);
      streetName.setValidators(Validators.required);
      streetType.setValidators(Validators.required);
    }
    streetNumber.updateValueAndValidity();
    streetName.updateValueAndValidity();
    streetType.updateValueAndValidity();


    this.new_val = event;
    this.old_val = '';
    var property = '';


  }

  addRemoveValidation(event, index) {

    if (event == false) {
      this.formArrApplicantAddress.controls[index]['controls'].addi_address_type.setValidators(Validators.required);
      this.formArrApplicantAddress.controls[index]['controls'].addi_address_type.updateValueAndValidity();
      this.formArrApplicantAddress.controls[index]['controls'].addi_address_format.setValidators(Validators.required);
      this.formArrApplicantAddress.controls[index]['controls'].addi_address_format.updateValueAndValidity();

      if (this.formArrApplicantAddress.value[index].addi_address_format == "standard" || this.formArrApplicantAddress.value[index].addi_address_format == "nonStandard") {
        this.formArrApplicantAddress.controls[index]['controls'].addi_street_number.setValidators(Validators.required);
        this.formArrApplicantAddress.controls[index]['controls'].addi_street_number.updateValueAndValidity();
        this.formArrApplicantAddress.controls[index]['controls'].addi_street_name.setValidators(Validators.required);
        this.formArrApplicantAddress.controls[index]['controls'].addi_street_name.updateValueAndValidity();
        this.formArrApplicantAddress.controls[index]['controls'].addi_street_type.setValidators(Validators.required);
        this.formArrApplicantAddress.controls[index]['controls'].addi_street_type.updateValueAndValidity();
      } else {
        this.formArrApplicantAddress.controls[index]['controls'].addi_street_number.setValidators(null);
        this.formArrApplicantAddress.controls[index]['controls'].addi_street_number.updateValueAndValidity();
        this.formArrApplicantAddress.controls[index]['controls'].addi_street_name.setValidators(null);
        this.formArrApplicantAddress.controls[index]['controls'].addi_street_name.updateValueAndValidity();
        this.formArrApplicantAddress.controls[index]['controls'].addi_street_type.setValidators(null);
        this.formArrApplicantAddress.controls[index]['controls'].addi_street_type.updateValueAndValidity();
      }
      this.formArrApplicantAddress.controls[index]['controls'].addi_city.setValidators(Validators.required);
      this.formArrApplicantAddress.controls[index]['controls'].addi_city.updateValueAndValidity();
      this.formArrApplicantAddress.controls[index]['controls'].addi_state.setValidators(Validators.required);
      this.formArrApplicantAddress.controls[index]['controls'].addi_state.updateValueAndValidity();
      this.formArrApplicantAddress.controls[index]['controls'].addi_postcode.setValidators(Validators.required);
      this.formArrApplicantAddress.controls[index]['controls'].addi_postcode.updateValueAndValidity();
      this.formArrApplicantAddress.controls[index]['controls'].addi_country.setValidators(Validators.required);
      this.formArrApplicantAddress.controls[index]['controls'].addi_country.updateValueAndValidity();
      this.formArrApplicantAddress.controls[index]['controls'].addi_housing_situation.setValidators(null);
      this.formArrApplicantAddress.controls[index]['controls'].addi_housing_situation.updateValueAndValidity();
      this.formArrApplicantAddress.controls[index]['controls'].addi_move_in_date.setValidators(Validators.required);
      this.formArrApplicantAddress.controls[index]['controls'].addi_move_in_date.updateValueAndValidity();
    } else {
      this.formArrApplicantAddress.controls[index]['controls'].addi_address_type.setValidators(null);
      this.formArrApplicantAddress.controls[index]['controls'].addi_address_type.updateValueAndValidity();
      this.formArrApplicantAddress.controls[index]['controls'].addi_address_format.setValidators(null);
      this.formArrApplicantAddress.controls[index]['controls'].addi_address_format.updateValueAndValidity();
      this.formArrApplicantAddress.controls[index]['controls'].addi_street_number.setValidators(null);
      this.formArrApplicantAddress.controls[index]['controls'].addi_street_number.updateValueAndValidity();
      this.formArrApplicantAddress.controls[index]['controls'].addi_street_name.setValidators(null);
      this.formArrApplicantAddress.controls[index]['controls'].addi_street_name.updateValueAndValidity();
      this.formArrApplicantAddress.controls[index]['controls'].addi_street_type.setValidators(null);
      this.formArrApplicantAddress.controls[index]['controls'].addi_street_type.updateValueAndValidity();
      this.formArrApplicantAddress.controls[index]['controls'].addi_street_number.setValidators(null);
      this.formArrApplicantAddress.controls[index]['controls'].addi_street_number.updateValueAndValidity();
      this.formArrApplicantAddress.controls[index]['controls'].addi_street_name.setValidators(null);
      this.formArrApplicantAddress.controls[index]['controls'].addi_street_name.updateValueAndValidity();
      this.formArrApplicantAddress.controls[index]['controls'].addi_street_type.setValidators(null);
      this.formArrApplicantAddress.controls[index]['controls'].addi_street_type.updateValueAndValidity();

      this.formArrApplicantAddress.controls[index]['controls'].addi_city.setValidators(null);
      this.formArrApplicantAddress.controls[index]['controls'].addi_city.updateValueAndValidity();
      this.formArrApplicantAddress.controls[index]['controls'].addi_state.setValidators(null);
      this.formArrApplicantAddress.controls[index]['controls'].addi_state.updateValueAndValidity();
      this.formArrApplicantAddress.controls[index]['controls'].addi_postcode.setValidators(null);
      this.formArrApplicantAddress.controls[index]['controls'].addi_postcode.updateValueAndValidity();
      this.formArrApplicantAddress.controls[index]['controls'].addi_country.setValidators(null);
      this.formArrApplicantAddress.controls[index]['controls'].addi_country.updateValueAndValidity();
      this.formArrApplicantAddress.controls[index]['controls'].addi_housing_situation.setValidators(null);
      this.formArrApplicantAddress.controls[index]['controls'].addi_housing_situation.updateValueAndValidity();
      this.formArrApplicantAddress.controls[index]['controls'].addi_move_in_date.setValidators(null);
      this.formArrApplicantAddress.controls[index]['controls'].addi_move_in_date.updateValueAndValidity();
    }
  }

  public setAsPrimary($event, i, type) {

    this.addRemoveValidation($event._value, i);

  }

  editsetAsPrimary(i) {
    this.addRemoveValidation(false, i);

  }
  deleteSecondaryApplicant(index) {

    this.formArrApplicantAddress.removeAt(index);

  }

  codeInput(event) {

    let pass = /[4][8-9]{1}/.test(event.charCode) || /[5][0-7]{1}/.test(event.charCode);
    if (!pass) {
      return false;
    }
  }

  currentEmployeedaddi(value, index) {
    let gexpectFindWork = this.addreDetail.controls.addEmploymentItem['controls'][index].get('expectFindWork');
    let gstatusyourEmployment = this.addreDetail.controls.addEmploymentItem['controls'][index].get('statusyourEmployment');
    let gyour_occupation = this.addreDetail.controls.addEmploymentItem['controls'][index].get('your_occupation');
    let gstart_date = this.addreDetail.controls.addEmploymentItem['controls'][index].get('start_date');
    let gbusiness_name = this.addreDetail.controls.addEmploymentItem['controls'][index].get('business_name');
    let gnature_of_business = this.addreDetail.controls.addEmploymentItem['controls'][index].get('nature_of_business');
    if (value == 'yes') {

      gstatusyourEmployment.setValidators(Validators.required);
      gyour_occupation.setValidators(Validators.required);
      gstart_date.setValidators(Validators.required);
      gexpectFindWork.setValidators(null);
    } else {

      gexpectFindWork.setValidators(Validators.required);
      gstatusyourEmployment.setValidators(null);
      gyour_occupation.setValidators(null);
      gstart_date.setValidators(null);
    }
    gbusiness_name.setValidators(null);
    gnature_of_business.setValidators(null);

    gexpectFindWork.updateValueAndValidity();
    gstatusyourEmployment.updateValueAndValidity();
    gyour_occupation.updateValueAndValidity();
    gstart_date.updateValueAndValidity();
    gbusiness_name.updateValueAndValidity();
    gnature_of_business.updateValueAndValidity();
    this.signupSlider.resize();
    this.signupSlider.update();
  }

  populateDataForEdit(data) {

    debugger;

    let primary_address: any;
    let primary_previous_address: any = [];

    let additional_relation_address: any = [];
    let additional_realtion_previous_address: any = [];

    if (data.length > 0) {
      for (var i = 0; i < data.length; i++) {

        if (data[i].type == 'primary') {

           let primary_user = data[i].user_data;
           this.primaryData.controls.firstname.setValue(primary_user.firstname);
           this.primaryData.controls.lastname.setValue(primary_user.lastname);

          var add = data[i].contact_details.address;
          add.forEach(data => {
            if (data.type == 'current') {
              primary_address = data;

            }
            else {
              primary_previous_address.push(data);

            }
          })
        }
        else {
          var add = data[i].contact_details.address;
          let add_user = data[i].user_data;


          additional_relation_address.push(add);



        }
      }


    }


     if (Object.keys(primary_address).length > 0) {
      console.log('its working');
      this.addreDetail.get('address_type').setValue(primary_address.address_type);
      this.addreDetail.get('street_number').setValue(primary_address.street_number);
      this.addreDetail.get('street_name').setValue(primary_address.street_name);
      this.addreDetail.get('street_type').setValue(primary_address.street_type);
      this.addreDetail.get('address_format').setValue(primary_address.address_format);

      this.addreDetail.get('city').setValue(primary_address.city);
      this.addreDetail.get('state').setValue(primary_address.state);
      this.addreDetail.get('postcode').setValue(primary_address.postcode);
      this.addreDetail.get('country').setValue(primary_address.country);
      this.addreDetail.get('housing_situation').setValue(primary_address.housing_situation);

      this.addreDetail.get('building_name').setValue(primary_address.building_name);
      this.addreDetail.get('floor_number').setValue(primary_address.floor_number);
      this.addreDetail.get('move_in_date').setValue(primary_address.move_in_date);
      this.addreDetail.get('poboxlabel').setValue(primary_address.poboxlabel);
      this.addreDetail.get('unit_number').setValue(primary_address.unit_number);


      this.addreDetail.get('address_type').markAsTouched();

      this.addreDetail.get('address_format').markAsTouched();

      this.addreDetail.get('full_address').markAsTouched();

      this.addreDetail.get('floor_number').markAsTouched();

      this.addreDetail.get('unit_number').markAsTouched();

      this.addreDetail.get('building_name').markAsTouched();

      this.addreDetail.get('street_number').markAsTouched();

      this.addreDetail.get('street_name').markAsTouched();

      this.addreDetail.get('street_type').markAsTouched();

      this.addreDetail.get('poboxlabel').markAsTouched();

      this.addreDetail.get('city').markAsTouched();

      this.addreDetail.get('state').markAsTouched();

      this.addreDetail.get('postcode').markAsTouched();

      this.addreDetail.get('country').markAsTouched();

      this.addreDetail.get('move_in_date').markAsTouched();


     }




      if(primary_previous_address.length > 0){
        primary_previous_address.forEach(element => {
              console.log(element);
                if(element.address_format == 'standard') {
                  element.floor_number='';
                }
              this.formPreviousAddress.push(this.initaddPreviousAddressLoad(element));
        })

        if(this.formPreviousAddress['controls'].length > 0){

          (<FormArray>this.addreDetail.get('addPreviousAddressItem'))['controls'].forEach(element=>{


            element.get('previous_address_type').markAsTouched();

            element.get('previous_address_format').markAsTouched();

            element.get('previous_full_address').markAsTouched();

            element.get('previous_floor_number').markAsTouched();

            element.get('previous_unit_number').markAsTouched();

            element.get('previous_building_name').markAsTouched();

            element.get('previous_poboxlabel').markAsTouched();

            element.get('previous_street_number').markAsTouched();

            element.get('previous_street_name').markAsTouched();

            element.get('previous_street_type').markAsTouched();

            element.get('previous_city').markAsTouched();

            element.get('previous_state').markAsTouched();

            element.get('previous_postcode').markAsTouched();

            element.get('previous_country').markAsTouched();



            element.get('previous_move_in_date').markAsTouched();

            element.get('previous_move_out_date').markAsTouched();
          })
        }
      }


     if (additional_relation_address.length > 0) {

      additional_relation_address.forEach((addiItem, index) => {

       addiItem.forEach((element,prevIndex) => {

        if(element.type =="current") {
           if(!element.same_as_primary) {
             element.same_as_primary = false;
           }
          this.formArrApplicantAddress.push(this.initItemApplicantAddress2(element,index));
         }
         else
         {
            this.additionalPrevAddress(index).push(this.initItemRowsPreviousAddress3(element));

         }


       });



      })

      if((<FormArray>this.addreDetail.get('addAddressRelationshipItem')).controls.length > 0)
      {
        (<FormArray>this.addreDetail.get('addAddressRelationshipItem')).controls.forEach(element=>{
             element.get('addi_address_type').markAsTouched();

            element.get('addi_address_format').markAsTouched();

            element.get('addi_full_address').markAsTouched();

            element.get('addi_floor_number').markAsTouched();

            element.get('addi_unit_number').markAsTouched();

            element.get('addi_building_name').markAsTouched();

            element.get('addi_street_number').markAsTouched();

            element.get('addi_street_name').markAsTouched();

            element.get('addi_street_type').markAsTouched();

            element.get('addi_poboxlabel').markAsTouched();

            element.get('addi_city').markAsTouched();

            element.get('addi_state').markAsTouched();

            element.get('addi_postcode').markAsTouched();

            element.get('addi_country').markAsTouched();

            element.get('addi_housing_situation').markAsTouched();

            element.get('addi_move_out_date').markAsTouched();

            element.get('addi_move_in_date').markAsTouched();
         })
      }
    }


    if (additional_realtion_previous_address.length > 0) {
      additional_realtion_previous_address.forEach((element,index) => {

      })
    }

  }


  initaddAnotherApplicant(adfobj) {

    return this.formBuilder.group({

      secondary_firstname: [adfobj.secondary_firstname, Validators.compose([Validators.maxLength(30), Validators.required])],
      secondary_middlename: [adfobj.secondary_middlename, Validators.compose([Validators.maxLength(30)])],
      secondary_lastname: [adfobj.secondary_lastname, Validators.compose([Validators.maxLength(30), Validators.required])],
      secondary_email: [adfobj.secondary_email, Validators.compose([Validators.maxLength(100), Validators.required])],
      secondary_mobile_phone: [adfobj.secondary_mobile_phone, Validators.compose([Validators.maxLength(30), Validators.required])],
      secondary_date_of_birth: [adfobj.secondary_date_of_birth, Validators.compose([Validators.maxLength(30), Validators.required])],
      relationship_to_primary_applicant: ['', Validators.compose([Validators.maxLength(30), Validators.required])],
      deleted: [0],
      uid: [''],
      document_id: ['']
    });
  }
  initaddAnotherApplicant2() {

    return this.formBuilder.group({

      secondary_firstname: ['', Validators.compose([Validators.maxLength(30), Validators.required])],
      secondary_middlename: ['', Validators.compose([Validators.maxLength(30)])],
      secondary_lastname: ['', Validators.compose([Validators.maxLength(30), Validators.required])],
      secondary_email: ['', Validators.compose([Validators.maxLength(100), Validators.required])],
      secondary_mobile_phone: ['', Validators.compose([Validators.maxLength(30), Validators.required])],
      secondary_date_of_birth: ['', Validators.compose([Validators.maxLength(30), Validators.required])],
      relationship_to_primary_applicant: ['', Validators.compose([Validators.maxLength(30), Validators.required])],
      deleted: [0],
      uid: [''],
      document_id: ['']
    });
  }
  initItemRowsPreviousAddress2(formObj,index) {

    return this.formBuilder.group({
      addi_same_as_primary: ['false'],
      addi_address_type: [formObj.address_type, Validators.compose([Validators.maxLength(30)])],
      addi_address_format: [formObj.address_format, Validators.compose([Validators.maxLength(30)])],
      addi_full_address: [formObj.full_address, Validators.compose([Validators.maxLength(30)])],
      addi_floor_number: [formObj.floor_number, Validators.compose([Validators.maxLength(30)])],
      addi_unit_number: [formObj.unit_number, Validators.compose([Validators.maxLength(30)])],
      addi_building_name: [formObj.building_name, Validators.compose([Validators.maxLength(200)])],
      addi_street_number: [formObj.street_number, Validators.compose([Validators.maxLength(30)])],
      addi_street_name: [formObj.street_name, Validators.compose([Validators.maxLength(30)])],
      addi_street_type: [formObj.street_type, Validators.compose([Validators.maxLength(30)])],
      addi_poboxlabel: [formObj.poboxlabel, Validators.compose([Validators.maxLength(30)])],
      addi_city: [formObj.city, Validators.compose([Validators.maxLength(30)])],
      addi_state: [formObj.state, Validators.compose([Validators.maxLength(30)])],
      addi_postcode: [formObj.postcode, Validators.compose([Validators.maxLength(30)])],
      addi_country: [formObj.country, Validators.compose([Validators.maxLength(30)])],
      addi_housing_situation: [formObj.housing_situation, Validators.compose([Validators.maxLength(30)])],
      addi_move_out_date: ['', Validators.compose([Validators.maxLength(30)])],
      addi_move_in_date: [formObj.move_in_date, Validators.compose([Validators.maxLength(30)])],
      document_id: [''],
      deleted: [''],
      index: index,
      addPAddressRelationshipItem: this.formBuilder.group({
        addPreviousAddressRelationshipItem: this.formBuilder.array([])
      })
    });
  }
  get primaryApplicantdata() {
    return this.primaryData.get('addAnotherApplicantItem') as FormArray;
  }
  setAddressDetail(primaryDetails) {


    this.primaryData.controls.firstname.setValue(primaryDetails.value.firstname);
    this.primaryData.controls.lastname.setValue(primaryDetails.value.lastname);
    primaryDetails.value.addAnotherApplicantItem.forEach((element, index) => {


      if(this.primaryApplicantdata.value[index]) {
      this.primaryApplicantdata.value[index].secondary_firstname = element.secondary_firstname;
      this.primaryApplicantdata.value[index].secondary_lastname = element.secondary_lastname;
      }
      else {
        this.primaryApplicantdata.push(this.initaddAnotherApplicant(element));
      }


    });

  }
  setAddiAddressDetail(additionalDetail) {

    debugger;
    console.log(this.primaryApplicantdata);
    console.log(additionalDetail);
    while ((<FormArray>(<FormArray>this.addreDetail.get('addAddressRelationshipItem')).at(additionalDetail.additional_index).get('addPAddressRelationshipItem')).length !== 0) {
      (<FormArray>(<FormArray>this.addreDetail.get('addAddressRelationshipItem')).at(additionalDetail.additional_index).get('addPAddressRelationshipItem')).removeAt(0);
    }
    //debugger;
    this.primaryApplicantdata.at(additionalDetail.additional_index).get('secondary_firstname').setValue(additionalDetail.user_data.firstname);
    this.primaryApplicantdata.at(additionalDetail.additional_index).get('secondary_lastname').setValue(additionalDetail.user_data.lastname);

    //console.log(this.formArrApplicantAddress);
    debugger;
    if(additionalDetail.contact_details.address) {
      additionalDetail.contact_details.address.forEach((addiItem, index) => {


        if(addiItem.type =="current") {
            if(addiItem.same_as_primary) {
              this.formArrApplicantAddress.at(additionalDetail.additional_index).get('addi_same_as_primary').setValue(addiItem.same_as_primary);
            }
            else {
              this.formArrApplicantAddress.at(additionalDetail.additional_index).get('addi_same_as_primary').setValue(false);
            }
          this.formArrApplicantAddress.at(additionalDetail.additional_index).get('addi_address_type').setValue(addiItem.address_type);
          this.formArrApplicantAddress.at(additionalDetail.additional_index).get('addi_address_format').setValue(addiItem.address_format);
          this.formArrApplicantAddress.at(additionalDetail.additional_index).get('addi_full_address').setValue(addiItem.full_address);
          this.formArrApplicantAddress.at(additionalDetail.additional_index).get('addi_floor_number').setValue(addiItem.floor_number);
          this.formArrApplicantAddress.at(additionalDetail.additional_index).get('addi_unit_number').setValue(addiItem.unit_number);
          this.formArrApplicantAddress.at(additionalDetail.additional_index).get('addi_building_name').setValue(addiItem.building_name);
          this.formArrApplicantAddress.at(additionalDetail.additional_index).get('addi_street_number').setValue(addiItem.street_number);
          this.formArrApplicantAddress.at(additionalDetail.additional_index).get('addi_street_name').setValue(addiItem.street_name);
          this.formArrApplicantAddress.at(additionalDetail.additional_index).get('addi_street_type').setValue(addiItem.street_type);
          this.formArrApplicantAddress.at(additionalDetail.additional_index).get('addi_poboxlabel').setValue(addiItem.poboxlabel);
          this.formArrApplicantAddress.at(additionalDetail.additional_index).get('addi_city').setValue(addiItem.city);
          this.formArrApplicantAddress.at(additionalDetail.additional_index).get('addi_state').setValue(addiItem.state);
          this.formArrApplicantAddress.at(additionalDetail.additional_index).get('addi_postcode').setValue(addiItem.postcode);
          this.formArrApplicantAddress.at(additionalDetail.additional_index).get('addi_country').setValue(addiItem.country);
          this.formArrApplicantAddress.at(additionalDetail.additional_index).get('addi_housing_situation').setValue(addiItem.housing_situation);
          this.formArrApplicantAddress.at(additionalDetail.additional_index).get('addi_move_out_date').setValue(addiItem.move_out_date);
          this.formArrApplicantAddress.at(additionalDetail.additional_index).get('addi_move_in_date').setValue(addiItem.move_in_date);

         }
         else
         {
            this.additionalPrevAddress(additionalDetail.additional_index).push(this.initItemRowsPreviousAddress3(addiItem));
         }



     })
    }


    // primaryDetails.value.addAnotherApplicantItem.forEach((element, index) => {


    //   if(this.primaryApplicantdata.value[index]) {
    //   this.primaryApplicantdata.value[index].secondary_firstname = element.secondary_firstname;
    //   this.primaryApplicantdata.value[index].secondary_lastname = element.secondary_lastname;
    //   }
    //   else {
    //     this.primaryApplicantdata.push(this.initaddAnotherApplicant(element));
    //   }


    // });

  }
  setApplicantDetail(Appindex) {


  }
  testing()
  {

    this.addreDetail.get('address_type').markAsTouched();

    this.addreDetail.get('address_format').markAsTouched();

    this.addreDetail.get('full_address').markAsTouched();

    this.addreDetail.get('floor_number').markAsTouched();

    this.addreDetail.get('unit_number').markAsTouched();

    this.addreDetail.get('building_name').markAsTouched();

    this.addreDetail.get('street_number').markAsTouched();

    this.addreDetail.get('street_name').markAsTouched();

    this.addreDetail.get('street_type').markAsTouched();

    this.addreDetail.get('poboxlabel').markAsTouched();

    this.addreDetail.get('city').markAsTouched();

    this.addreDetail.get('state').markAsTouched();

    this.addreDetail.get('postcode').markAsTouched();

    this.addreDetail.get('country').markAsTouched();

    this.addreDetail.get('move_in_date').markAsTouched();


  }

  onHandleHousingSituation(event)
  {
    //debugger;

    const housingSituation=event.target.value;
    console.log(housingSituation);
    debugger;
    if(housingSituation == 'Own Home with Mortgage'){
      this.housingsituation_evtemit2.emit();

      // this.adfFormService.housingsituation=housingSituation;
      // // this.RealEstateAssets.demo();
      // this.housingsituation_evtemit1.emit();
    }
    else{
      // this.RealEstateAssets.demo2();
      //this.housingsituation_evtemit2.emit();
      this.adfFormService.housingsituation=housingSituation;
      // this.RealEstateAssets.demo();
      this.housingsituation_evtemit1.emit();
    }
  }
}


// WEBPACK FOOTER //
// ./src/pages/adf-page/component/primary-applicant/address-detail/address-detail.ts